import {
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react'

interface BUContextType {
  selectedBuId: string | null
  setSelectedBuId: (id: string | null) => void
}

const BUContext = createContext<BUContextType | null>(null)

const STORAGE_KEY = 'km_selected_bu'

function readFromStorage(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || null
  } catch {
    return null
  }
}

export function BUProvider({ children }: { children: React.ReactNode }) {
  const [selectedBuId, setSelectedBuIdState] = useState<string | null>(
    () => readFromStorage()
  )

  const setSelectedBuId = useCallback((id: string | null) => {
    setSelectedBuIdState(id)
    try {
      if (id) {
        sessionStorage.setItem(STORAGE_KEY, id)
      } else {
        sessionStorage.removeItem(STORAGE_KEY)
      }
    } catch { /* storage non disponibile */ }
  }, [])

  return (
    <BUContext.Provider value={{ selectedBuId, setSelectedBuId }}>
      {children}
    </BUContext.Provider>
  )
}

export function useBUContext() {
  const ctx = useContext(BUContext)
  if (!ctx) throw new Error('useBUContext must be used within BUProvider')
  return ctx
}
